export enum TableValueTypeEnum {
  DEFAULT = 'DEFAULT',
  TAG = 'TAG',
  SCALE = 'SCALE',
  CHECK = 'CHECK'
}
